import Component from './components/Profile';
import { PATH } from './constants';

export { PATH };
export default Component;
